import { render, staticRenderFns } from "./index_v3.vue?vue&type=template&id=79947abe&scoped=true"
import script from "./index_v3.vue?vue&type=script&lang=js"
export * from "./index_v3.vue?vue&type=script&lang=js"
import style0 from "./index_v3.vue?vue&type=style&index=0&id=79947abe&prod&scoped=true&lang=css"
import style1 from "./index_v3.vue?vue&type=style&index=1&id=79947abe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_yhenekn6hnf4pbbtdhpnebbsqm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79947abe",
  null
  
)

export default component.exports